import React from 'react';
import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { IoAddCircleSharp } from "react-icons/io5";


function StickyTitle(props) {

  return (
    <div
      className={`sticky w-[full] flex ${(props.multibutton || props.menubutton) ? "md:flex-row flex-col pb-2":""} items-center justify-between top-0 bg-white shadow-md px-4 lg:px-16 z-10`}>
      <h1 className=" text-xl md:text-3xl p-2 ml-0 lg:ml-5 mt-2 mb-2 font-semibold font-poppins">{props.title ? props.title : "Sticky Title"}</h1>

      {!props.no_button && (props.menubutton === true ? (<>
        <Menu as="div" className="mr-4 relative inline-block text-left">
          <div>
            <Menu.Button className="bg-[#003A75] inline-flex w-full items-center justify-center gap-2 rounded-md  px-4 py-2 text-sm font-medium text-white hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
              <IoAddCircleSharp size={25}  />
              <p className=" text-lg md:text-2xl font-bold font-poppins">Create New</p>
              <ChevronDownIcon
                className=" -mr-1 mt-0 h-5 w-5 text-violet-200 hover:text-violet-100"
                aria-hidden="true"
              />
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="px-1 py-1 ">
                <Menu.Item>
                  {({ active }) => (
                    <button onClick={props.button_action}
                      className={`${active ? 'bg-[#007FFF] text-white' : 'text-gray-900'
                        } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mr-1">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M21 7.5l-9-5.25L3 7.5m18 0l-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9" />
                      </svg>

                      Item
                    </button>
                  )}
                </Menu.Item>
                <Menu.Item>
                  {({ active }) => (
                    <button onClick={props.button_action}
                      className={`${active ? 'bg-[#007FFF] text-white' : 'text-gray-900'
                        } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                    >

                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mr-1">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z" />
                      </svg>

                      Service

                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </>) : props.multibutton === true ? (<>
        <div className=' flex items-center gap-5'>
          <button onClick={props.button_action} className='bg-[#003A75] w-fit flex items-center gap-2 text-xs md:text-2xl font-bold font-poppins border rounded-md text-white py-2 px-4  hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75'><IoAddCircleSharp className=' sm:block hidden' size={25}  />{props.button ? props.button : "New Client"}</button>
          <button onClick={props.button_action2} className='bg-[#003A75] w-fit flex items-center gap-2 text-xs md:text-2xl font-bold font-poppins border rounded-md text-white py-2 px-4  hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75'><IoAddCircleSharp className=' sm:block hidden' size={25}  />{props.button2 ? props.button2 : "New Client"}</button>
        </div>
      </>) : (<>
        <button onClick={props.button_action} className='bg-[#003A75] w-fit text-lg md:text-2xl font-bold font-poppins border rounded-md text-white py-2 px-4 flex items-center gap-2 hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75'><IoAddCircleSharp className=' sm:block hidden' size={25}  />{props.button ? props.button : "New Client"}</button>
      </>))}
    </div>
  );
}

export default StickyTitle;
